<template>
    <!-- Mobile: single "label — value" row (v2 mobile stat card).
         sm+: stacked label over large value (v2 desktop stat card). -->
    <div
        class="flex-1 min-w-0 px-4 py-3.5 sm:px-6 sm:py-4 flex items-center justify-between gap-3 sm:block"
    >
        <!-- Label row -->
        <div class="flex items-center gap-1.5 min-w-0 sm:mb-1">
            <span class="body-md text-fg-secondary truncate">{{ label }}</span>
            <slot name="label-suffix" />
        </div>
        <!-- Value row (suffix sits before the value on mobile, after on sm+) -->
        <div
            class="flex flex-row-reverse sm:flex-row items-center gap-1.5 flex-shrink-0"
        >
            <span
                class="text-base font-semibold sm:heading-xl whitespace-nowrap"
                :class="accent ? 'text-fg-brand' : 'text-fg-primary'"
            >
                {{ value }}<span
                    v-if="unit"
                    class="text-sm sm:text-base font-medium ml-1"
                    :class="accent ? 'text-fg-brand/70' : 'text-fg-tertiary'"
                    >{{ unit }}</span
                >
            </span>
            <slot name="value-suffix" />
        </div>
    </div>
</template>

<script setup>
/**
 * Presentational summary stat used in the My Spending header row
 * (Spent / Earned / Untapped), styled on the Design System v2 tokens.
 * Wrap several in a bordered, divided container in the parent.
 */
defineProps({
    label: {
        type: String,
        required: true,
    },
    value: {
        type: [String, Number],
        default: '—',
    },
    /** Smaller unit shown after the value, e.g. "pts". */
    unit: {
        type: String,
        default: '',
    },
    /** Render the value in the brand accent (used for Untapped rewards). */
    accent: {
        type: Boolean,
        default: false,
    },
});
</script>
